import { Injectable } from '@angular/core';
import { RequestService } from '../request/request.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private _requestService: RequestService) {}

  dadosFornecedor(companyID, restrictionKey) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `company/api/Company/Get`,
      'GET',
      true,
      null,
      header
    );
  }

  dadosUsuario(companyID, restrictionKey, userID) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `user/api/User/Get/${userID}`,
      'GET',
      true,
      null,
      header
    );
  }

  //Módulos por fornecedor
  modulosFornecedor(companyID, restrictionKey) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `company/api/Company/GetContractedModules`,
      'GET',
      true,
      null,
      header
    );
  }

  //Gráfico: Qtde de Obras por Módulo
  qtdeObrasModulo(companyID, restrictionKey, moduleID: number) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `work/ListQuantityWorksByModule/${moduleID}`,
      'GET',
      true,
      null,
      header
    );
  }

  //Gráfico: Fase da Obra
  faseDaObra(companyID, restrictionKey, moduleID: number) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `work/ListWorkPhase/${moduleID}`,
      'GET',
      true,
      null,
      header
    );
  }

  //Gráfico: Tipo de Obra
  tipoDeObra(companyID, restrictionKey, moduleID: number) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `work/ListTypeOfWork/${moduleID}`,
      'GET',
      true,
      null,
      header
    );
  }

  //Gráfico: Padrão de Obra
  padraoDeObra(companyID, restrictionKey, moduleID: number) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `work/ListPatternWork/${moduleID}`,
      'GET',
      true,
      null,
      header
    );
  }

  //Gráfico: UF
  listaUF(companyID, restrictionKey, moduleID: number) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `work/ListWorkState/${moduleID}`,
      'GET',
      true,
      null,
      header
    );
  }

  //Gráfico: Obra por Responsáveis
  obraPorResponsaveis(companyID, restrictionKey, moduleID: number) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `work/ListResponsibleWork/${moduleID}`,
      'GET',
      true,
      null,
      header
    );
  }

  //Gráfico: Status de Negociações
  statusNegociacoes(companyID, restrictionKey, moduleID: number) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `work/ListNegotiationStatusWork/${moduleID}`,
      'GET',
      true,
      null,
      header
    );
  }
}
